import { render } from "./VarHeader.vue?vue&type=template&id=4d112b26&scoped=true"
import script from "./VarHeader.vue?vue&type=script&lang=js"
export * from "./VarHeader.vue?vue&type=script&lang=js"

import "./VarHeader.vue?vue&type=style&index=0&id=4d112b26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d112b26"]])

export default __exports__